import { TOptions } from 'i18next';
import React from 'react';

import { useTranslation } from 'react-i18next';

export type TFn<WithDataKey extends boolean | undefined = undefined> = (
  key: string,
  translationWithDataKey?: WithDataKey,
  options?: TOptions
) => WithDataKey extends boolean
  ? WithDataKey extends false
    ? string
    : React.ReactElement<{ 'data-key': string }>
  : React.ReactElement<{ 'data-key': string }>;

export const useTranslationWithDataKey = () => {
  const { t, i18n, ready } = useTranslation();
  const customTranslationWithDataKey = (key: string, translationWithDataKey = true, options?: TOptions) => {
    if (translationWithDataKey) {
      return React.createElement('span', { 'data-key': key }, t(key, options));
    }

    return t(key, options);
  };

  return {
    t: customTranslationWithDataKey as TFn<true> & TFn<false>,
    i18n,
    ready,
  };
};
